import styled from "styled-components";
import { Button, Card } from "react-bootstrap";

export const Wrapper = styled(Card)`
  width: 18rem;
  margin: 10px;
`;

export const Image = styled(Card.Img)``;

export const Content = styled(Card.Body)``;

export const Title = styled(Card.Title)``;

export const Description = styled(Card.Text)``;

export const SaveButton = styled(Button)``;
